import m3m from "../../../public/developers/images/logo/m3m.png";
import tarc from "../../../public/developers/images/logo/tarc.png"
import dlf from "../../../public/developers/images/logo/dlf.png"
import smartworld from "../../../public/developers/images/logo/smartworld.png";
import Fours from "../../../public/developers/images/logo/4s.png";
import whiteland from "../../../public/developers/images/logo/whiteland.png"
import Shapoorji from "../../../public/developers/images/logo/Shapoorji.png"
import Majestique from "../../../public/developers/images/logo/Majestique.png"
import Lodha from "../../../public/developers/images/logo/Lodha.png"
import Kotle from "./images/logo/Kotle.png"
import Mahindra from "../../../public/developers/images/logo/mahindra.png"
import eldeco from "../../../public/developers/images/logo/eldeco.png"
import Godrej from "./images/logo/godrej.png"
import birla from "../../../public/developers/images/logo/birla.png"
import max from "../../../public/developers/images/logo/max.png"
import signatureglobal from "../../../public/developers/images/logo/SignatureGlobal.png"
import silverglades from "../../../public/developers/images/logo/Silverglades.png"
import sobha from "../../../public/developers/images/logo/sobha.png"
import gera  from "../../../public/developers/images/logo/Gera.png"
import neo from "../../../public/developers/images/logo/Neo.png"
import kalpataru from "../../../public/developers/images/logo/Kalpataru.png"
import mantra from "../../../public/developers/images/logo/Mantra.png"
import saheel from "../../../public/developers/images/logo/Saheel.png"
import brigade from "../../../public/developers/images/logo/Brigade.png"
import purvakara from"../../../public/developers/images/logo/Purvakara.png"
import rustamji from "../../../public/developers/images/logo/Rustomjee.png"
import hiranandni from "../../../public/developers/images/logo/Hiranandani.png"
import sattva from "../../../public/developers/images/logo/Sattva.png"
import Casagrand from "../../../public/developers/images/logo/Casagrand.png"
import Conscient from "../../../public/developers/images/logo/Conscient.png"
import Mantri from "../../../public/developers/images/logo/Mantri.png"
import cghs from "../../../public/developers/images/logo/cghs.png"
import ekta from "../../../public/developers/images/logo/ekta.png"
import trinity from "../../../public/developers/images/logo/trinity.webp"
import experion from "../../../public/developers/images/logo/experion.png"
import tvs from "../../../public/developers/images/logo/tvs.png"
import ganga from "../../../public/developers/images/logo/goelganga.png"
import shubh from "../../../public/developers/images/logo/shubh.png"
import embassy from "../../../public/developers/images/logo/embassy.png"




const shuffleArray = (array) => {
  let shuffledArray = [...array]; // Create a copy to avoid mutating the original array
  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
  }
  return shuffledArray;
};
export const developerlogo = shuffleArray([
  { image: m3m, alt: "m3m", link: `/developers/m3m`, location: "gurugram" },
  { image: tarc, link: `/developers/tarc`, alt: "tarc", location: "gurugram" },
  { image: dlf, alt: "dlf", link: `/developers/dlf`, location: "gurugram" },
  { image: smartworld, link: `/developers/smartworld`, alt: "smartworld", location: "gurugram" },
  { image: Fours, link: `/developers/4s`, alt: "Fours", location: "gurugram" },
  { image: whiteland, link: `/developers/whiteland`, alt: "whiteland", location: "gurugram" },
  { image: Conscient, link: `/developers/conscient`, alt: "Conscient", location: "gurugram" },
  { image: max, link: `/developers/max-estates`, alt: "MaxEstates", location: "gurugram" },
  { image: signatureglobal, link: `/developers/signature-global`, alt: "SignatureGlobal", location: "gurugram" },
  { image: silverglades, link: `/developers/silverglades`, alt: "Silverglades", location: "gurugram" },
  { image: sobha, link: `/developers/sobha`, alt: "Sobha", location: "bengaluru" },
  { image: eldeco, link: `/developers/eldeco`, alt: "Eldeco", location: "gurugram" },
  { image: birla, link: `/developers/birla`, alt: "Birla", location: "bengaluru" },
  { image: Godrej, link: `/developers/godrej`, alt: "godrej", location: "pune" },
  { image: Shapoorji, link: `/developers/shapoorji-pallonji`, alt: "shapoorji", location: "pune" },
  { image: Mahindra, link: `/developers/mahindra-lifespaces`, alt: "mahindra", location: "mumbai" },
  { image: gera, link: `/developers/gera`, alt: "Gera", location: "pune" },
  { image: Lodha, link: `/developers/lodha`, alt: "Lodha", location: "bengaluru" },
  { image: neo, link: `/developers/neo`, alt: "Neo", location: "mumbai" },
  { image: mantra, link: `/developers/mantra`, alt: "Mantra", location: "pune" },
  { image: Majestique, link: `/developers/majestique`, alt: "Majestique", location: "pune" },
  { image: saheel, link: `/developers/saheel`, alt: "Saheel", location: "pune" },
  { image: ganga, link: `/developers/ganga`, alt: "Ganga", location: "pune" },
  { image: Kotle, link: `/developers/kolte`, alt: "Kolte", location: "pune" },
  { image: kalpataru, link: `/developers/kalpataru`, alt: "Kalpataru Group", location: "mumbai" },
  { image: hiranandni, link: `/developers/hiranandani`, alt: "Hiranandani Group", location: "mumbai" },
  { image: ekta, link: `/developers/ektaworld`, alt: "Ekta World", location: "mumbai" },
  { image: rustamji, link: `/developers/rustomjee`, alt: "Rustomjee", location: "mumbai" },
  { image: purvakara, link: `/developers/puravankara`, alt: "Purvakara", location: "bengaluru" },
  { image: brigade, link: `/developers/brigade`, alt: "Brigade Enterprises", location: "bengaluru" },
  { image: sattva, link: `/developers/sattva`, alt: "Sattva", location: "bengaluru" },
  { image: Mantri, link: `/developers/mantri`, alt: "Mantri Developers", location: "bengaluru" },
  { image: trinity, link: `/developers/trinity`, alt: "Trinity Infratech", location: "gurugram" },
  { image: experion, link: `/developers/experion`, alt: "Experion", location: "gurugram" },
  { image: tvs, link: `/developers/tvs`, alt: "TVS", location: "bengaluru" },
  { image: shubh, link: `/developers/shubh`, alt: "shubh", location: "pune" },
  { image: embassy, link: `/developers/embassy`, alt: "embassy", location: "bengaluru" },
  

]);

